import { get, pick } from 'lodash';
import { useAuth0 } from 'hooks/Auth0/Auth0';
import { camelToSnake } from 'helpers/camelToSnake/camelToSnake';
import { useSessionContext } from 'contexts/sessionProvider/SessionProvider';
import { ContactDetails } from './types';

export const useContact = (): ContactDetails => {
  const { user, appState } = useAuth0();
  const { accountDetail } = useSessionContext();
  const myobIdentityId = user?.['https://id.myob.com/user_id']?.toLowerCase();
  const myobIdEmail = user?.email;

  const contactDetail = pick(
    // TODO: Remove the value from appState when new trial AB testing is finished.
    accountDetail ?? get(appState, 'clientInformation'),
    'firstName',
    'lastName',
    'phoneNumber',
    'sendPromotions'
  );

  return camelToSnake({
    ...contactDetail,
    email: myobIdEmail,
    identityId: myobIdentityId
  }) as ContactDetails;
};
